import { render } from "./control-time.vue?vue&type=template&id=503ca29d&ts=true"
import script from "./control-time.vue?vue&type=script&lang=ts"
export * from "./control-time.vue?vue&type=script&lang=ts"

import "./control-time.vue?vue&type=style&index=0&id=503ca29d&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__